import React, { useState } from "react";
import "./Rps.css";

export default function Rps(prop) {
    const [player, setPlayer] = useState(null);
    const [computer, setComputer] = useState(null);
    const [result, setResult] = useState("");
    const [winNum, setWinNum] = useState(0);
    const [drawNum, setDrawNum] = useState(0);
    const [loseNum, setLoseNum] = useState(0);

    const choices = ["✊", "✋", "✌️"];

    const handleChoice = (choice) => {
        const playerChoice = choices[choice];
        setPlayer(playerChoice);

        const computerChoice = choices[Math.floor(Math.random() * 3)];
        setComputer(computerChoice);

        const winner = checkWinner(playerChoice, computerChoice);
        setResult(winner);

        if (winner === "You Win!") {
            setWinNum(winNum + 1);
        } else if (winner === "Draw") {
            setDrawNum(drawNum + 1);
        } else {
            setLoseNum(loseNum + 1);
        }
    };

    const checkWinner = (playerChoice, computerChoice) => {
        if (playerChoice === computerChoice) {
            return "Draw";
        } else if (
            (playerChoice === "✊" && computerChoice === "✌️") ||
            (playerChoice === "✋" && computerChoice === "✊") ||
            (playerChoice === "✌️" && computerChoice === "✋")
        ) {
            return "You Win!";
        } else {
            return "You Lose!";
        }
    };
    return (
        <div className={`${prop.mode}`}>
            <div id="gameDiv">
                <div className="texts">
                    <h1 className="gameText" id="playerText">
                        Player: {player}
                    </h1>
                    <h1 className="gameText" id="computerText">
                        Computer:{computer}
                    </h1>
                </div>
                <h1 className="gameText" id="resultText">
                    Result:{result}
                </h1>

                <div className="buttonRps">
                    
                    {choices.map((choice, index) => (
                        <button
                            className="choiceBtn"
                            key={index}
                            onClick={() => handleChoice(index)}>
                            {choice}
                        </button>
                    ))}
                </div>

                <div className="scores">
                    <h2 className="score" id="win">
                        Wins:{winNum}
                    </h2>
                    <h2 className="score" id="draw">
                        Draw:{drawNum}
                    </h2>
                    <h2 className="score" id="lose">
                        Lose:{loseNum}
                    </h2>
                </div>
            </div>
        </div>
    );
}
